/* eslint-disable import/prefer-default-export */
import React from 'react';
import { largeCurrencyFormat, sharesFormat } from 'common/formats/formats';
import { GridDateEditor, GridDateValueViewer } from 'components/FeaturedSpreadsheet/components';
import { LedgerGridDate } from 'components/LedgerTable/components';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { CashDistributionLedgerAcquisition } from 'pages/CapTable/fund-ownership/components/cash-distribution/CashDistributionLedger.props';
import { CONVERSION_DATE_ALIAS } from 'pages/CapTable/fund-ownership/components/shares-ledger/constants';
import generatePurchaseDateBaseConfig from 'pages/CapTable/fund-ownership/components/shares-ledger/utilities/generatePurchaseDateBaseConfig';
import generatePurchaseDateOptions from 'pages/CapTable/fund-ownership/components/shares-ledger/utilities/generatePurchaseDateOptions';

export const colConfig = (acquisitions: CashDistributionLedgerAcquisition[], sharesMaxDecimalPlaces: number) => {
  const acquisitionOptions = generatePurchaseDateOptions(acquisitions);
  const purchaseDatePickerConfig = generatePurchaseDateBaseConfig(acquisitionOptions);
  purchaseDatePickerConfig.convertedTable = true;

  return [
    purchaseDatePickerConfig,
    {
      value: 'Date Converted',
      alias: CONVERSION_DATE_ALIAS,
      width: '175px',
      gridDateComponent: LedgerGridDate,
      dataEditor: (props: ICell) => <GridDateEditor {...props} />,
      valueViewer: (props: ICell) => <GridDateValueViewer {...props} slashFormatted />,
      isRequired: true,
    },
    {
      value: 'Shares',
      alias: 'shares',
      width: '175px',
      format: sharesFormat,
      maxDecimalDigits: sharesMaxDecimalPlaces,
      minValue: 1,
      gridType: 'number',
      isRequired: true,
    },
    {
      value: 'Converted Amount',
      alias: 'amount',
      width: '175px',
      format: largeCurrencyFormat,
      gridType: 'number',
      isRequired: true,
    },
  ];
};

export default colConfig;
